import * as React from "react"
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={280} height={230} {...props}>
    <title>{"facial-hair/Goatee 2"}</title>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M237.595 65.88c2.74 2.81 5.37 5.82 7.85 8.93.69 4.94.85 9.94.22 15.1-.92 7.48-2.96 14.79-5.72 21.81-1.63-.23-3.24-.69-4.81-1.41-4.98-2.29-7.76-6.9-11.13-10.97-6.71-8.09-18.95-12.87-27.51-4.48-3.72 3.65-6.1 8.7-9.42 12.71-3.65 4.41-7.75 8.6-12.03 12.4-.53.48-1.08 1-1.65 1.51a363.17 363.17 0 0 1-7.01-8.24c-6.81-8.28-12.69-17.45-15.78-27.79-.98-3.28-1.59-6.7-1.83-10.15 3.03-3.76 6.49-7.18 10.42-10.01 11.85-8.55 25.5-9.94 39.7-10.68 14.69-.76 27.92.24 38.7 11.27m35.84 39.67c-.57-5.72-1.45-11.67-2.75-17.61-4.75-22.04-15.04-44.01-35.67-54.08-9.76-4.77-20.85-6.45-31.37-4.15-18.46-6.91-38.96.14-53.49 12.78-17.14 14.91-25.05 38.31-27.71 60.23-1.85 15.25-2.547 35.624 1.78 46.69 4.327 11.064 31.826 40.653 71.08 40.86 55.91.292 69.5-37.41 71.15-40.71 6.89-13.72 8.49-28.87 6.98-44.01"
    />
  </svg>
)
export default SvgComponent
